import React, { useState } from "react";
import Multiselect from "react-widgets/lib/Multiselect";

// Lista de palavras dinâmicas para verificação
const palavrasDinamicasValues = ["%devNome", "%devCpfCnpj", "%chassi", "%numero", "%renavam", "%numGravame"];

const messages = {
  emptyList: "Digite um valor e pressione Enter para adicionar.",
  createOption: (item) => "",
};

const FreeTagField = ({ input, label, meta: { touched, error, valid }, inline, small, description, rows = 1, ...rest }) => {
  const [inputValue, setInputValue] = useState("");

  // Calcula a altura com base no número de linhas
  const height = rows * 38;

  const handleCreate = (name) => {
    if (!name || name.trim() === "") return;

    // Verifica se é uma palavra dinâmica
    const isDinamica = palavrasDinamicasValues.includes(name.trim());

    // Cria um novo item com o texto digitado
    const newItem = {
      value: name.trim(),
      label: name.trim(),
      isDinamica: isDinamica, // Marca se é uma palavra dinâmica
    };

    // Verifica se o item já existe na lista
    const exists = (input.value || []).some((item) => item.value === newItem.value || item.label === newItem.label);

    if (!exists) {
      // Adiciona o novo item à lista existente
      const updatedValue = [...(input.value || []), newItem];
      input.onChange(updatedValue);
    }

    setInputValue("");
  };

  // Componente personalizado para renderizar cada tag
  const TagComponent = ({ item }) => {
    // Verifica se o item é uma palavra dinâmica
    const isDinamica = item.isDinamica || palavrasDinamicasValues.includes(item.value);

    return <span style={{ fontWeight: isDinamica ? "bold" : "normal" }}>{item.label || item.value}</span>;
  };

  return (
    <div className={`form-group ${touched && !valid ? "has-error" : ""} ${inline ? "row" : ""}`}>
      {label ? <label className={`font-weight-bold ${inline ? "col-sm-2 col-form-label" : ""}`}>{label}</label> : null}
      <Multiselect
        {...input}
        className={`${small ? "form-control form-control-sm" : "form-control"}`}
        style={{
          padding: "0rem 0rem",
          boxSizing: "content-box",
          minHeight: height ? `${height}px` : undefined,
        }}
        onBlur={() => input.onBlur()}
        value={input.value || []}
        messages={messages}
        allowCreate={true}
        onCreate={handleCreate}
        textField="label"
        valueField="value"
        filter="contains"
        data={[]}
        tagComponent={TagComponent}
        {...rest}
      />
      {description && <span className="help-block small">{description}</span>}
      <p className="text-danger">{touched ? error : ""}</p>
    </div>
  );
};

export default FreeTagField;
